/**
 * Paramètres des liens d'action Firebase Auth (mode, oobCode, etc.).
 * Firebase peut les placer dans ?search (avant le hash) ou dans le hash route.
 */
export function getAuthActionParams(locationSearch = '', locationHash = '') {
  const fromRouter = new URLSearchParams(locationSearch);
  const fromWindow = new URLSearchParams(
    typeof window !== 'undefined' ? window.location.search : ''
  );
  const hashQuery = locationHash.includes('?')
    ? locationHash.slice(locationHash.indexOf('?') + 1)
    : typeof window !== 'undefined' && window.location.hash.includes('?')
      ? window.location.hash.slice(window.location.hash.indexOf('?') + 1)
      : '';
  const fromHash = new URLSearchParams(hashQuery);

  const get = (key) => fromRouter.get(key) || fromWindow.get(key) || fromHash.get(key);

  return {
    mode: get('mode'),
    oobCode: get('oobCode'),
    apiKey: get('apiKey'),
    lang: get('lang'),
  };
}
